import { SingletonAreas } from "../flowchart/nodes/_service/singletonAreas";
import EquipmentJoker from "../flowchart/nodes/_service/singletonTools/equipmentJoker";

export var JokerEquipmentMixin = {
    name: "JokerEquipmentMixin",
    data() {
        return {
            jokerEquipmentList: [],
            processing: false,
            changeExternalCapacity: {},
            updataNodeInMixin: {}
        }
    },

    methods: {
        buildJokerEquipment(op, jokerCaption) {
            this.jokerEquipmentList = SingletonAreas.GetJokersEquipments(op);

            this.jokerEquipmentList.forEach((j, i) => {
                j.caption = jokerCaption && jokerCaption[i] ? jokerCaption[i] : j.op.split("|")[0] + " - " + j.area + " " + j.op.split("|")[1];
                j.Ocupacao = j.atProps.find(a => EquipmentJoker.occupancyTxTList.includes(a.key.toUpperCase()))
                console.log('j.atProps[0] :>> ', j.atProps[0]);
                if (j.atProps[0] && j.atProps[0].index.match(/Evaporador2/))
                    j.capacidade = j.atProps.find(a => a.key.toUpperCase() == "AREATOTAL")
                else
                    j.capacidade = j.atProps.find(a => EquipmentJoker.capacityTxTList.includes(a.key.toUpperCase()))
                j.equipments = j.nameEquip.filter(name => j.eqProps[name] && !!j.eqProps[name].find(attr => EquipmentJoker.onOffTxTList.includes(attr.key.toUpperCase()))).map(name => {
                    let attr = j.eqProps[name].find(attr => EquipmentJoker.onOffTxTList.includes(attr.key.toUpperCase()))
                    if (attr)
                        attr.value = parseInt(attr.value) ? true : false;
                    return attr
                })
            })
        },

        setAttrFilter3() {
            this.jokerEquipmentList.forEach((j) => {
                j.areaTotalDisponivelFiltracao = j.atProps.find(a => a.key == "areaTotalDisponivelFiltracao")
            })
        },

        ChangeOnOffJoker(value, prop, equipments, joker) {
            prop.value = value
            this.ChangeCapacidadeJoker(joker)
            this.ChangeAreaJoker(joker)
            this.switchStatusJoker(prop, equipments, true)
            this.updataNodeInMixin()
        },

        ChangeCapacidadeJoker(joker) {
            if (joker.capacidade) {
                joker.capacidade.value = 0;
                joker.equipments.forEach((e) => {
                    let cap = joker.eqProps[e.equipName].find((c) => c.key.toUpperCase() == "CAPACIDADE" || c.key.toUpperCase() == "VAZAONOMINAL" );
                    let isTrue = JSON.parse(e.value);
                    if (isTrue && cap)
                        joker.capacidade.value += parseFloat(String(cap.value).replace(",", "."));
                });
            }
        },

        ChangeAreaJoker(joker) {
            if (joker.areaTotalDisponivelFiltracao) {

                joker.areaTotalDisponivelFiltracao.value = 0;
                joker.equipments.forEach((e) => {
                    let cap = joker.eqProps[e.equipName].find((c) => c.key.toUpperCase() == "AREA");
                    if (e.value && cap)
                        joker.areaTotalDisponivelFiltracao.value += parseFloat(String(cap.value).replace(",", "."));
                });
            }
        },

        switchStatusJoker(target, equipments, switchJoker) {

            if (!target.value || this.processing || !this.jokerEquipmentList[0])
                return

            if (target.equipName != this.jokerEquipmentList[0].equipmentJoker) {
                this.changeIfOtherNamesAreTheSame(target, equipments)
                return
            }

            this.processing = true;

            if (!switchJoker) {
                this.jokerEquipmentList.forEach(joker => {
                    let eqFound = joker.equipments.find(j => j.equipName == target.equipName)
                    if(eqFound)
                        eqFound.value = !target.value
                    this.ChangeCapacidadeJoker(joker)
                })
            } else {
                let eqFound = equipments.find(eq => eq.equipName == target.equipName)
                if (eqFound) {
                    eqFound.value = !target.value
                    this.changeExternalCapacity()
                }

                this.jokerEquipmentList.forEach(joker => {
                    let eqFound2 = joker.equipments.find(j => {
                      return j.id != target.id && j.equipName == target.equipName
                    })
                    if (eqFound2 && eqFound2.equipName == this.jokerEquipmentList[0].equipmentJoker) {
                        eqFound2.value = !target.value
                        this.ChangeCapacidadeJoker(joker)
                    }
                })
            }
            this.processing = false;
        },

        changeIfOtherNamesAreTheSame(target, equipments) {
            let equip = equipments.find(p => p.equipName == target.equipName)
            if (equip && equip.id != target.id) {
                equip.value = !target.value
                this.changeExternalCapacity()
                this.updataNodeInMixin()
            }

            this.jokerEquipmentList.forEach(joker => {
                let equip2 = joker.equipments.find(eq => eq.equipName == target.equipName)
                if (equip2 && equip2.id != target.id) {
                    equip2.value = !target.value
                    this.ChangeCapacidadeJoker(joker)
                    this.updataNodeInMixin()
                }
            })
        },

        updateJokerNode(node, jokerList) {
            let jokers = []
            for (let i in jokerList) {
                let joker = jokerList[i]
                jokers.push({
                    ...joker,
                    equipments: joker.equipments.map(e => {
                        let eq = e.clone()
                        eq.value = e.value ? "1,00" : "0,00"
                        return eq
                    }),
                    atProps: joker.atProps.map(at => at.clone())
                })
            }
      
            node.jokerCaption = jokers.map(j => j.caption)
            node.jokers = jokers
        },

        updateCaption(caption, joker){
            joker.caption = caption
            this.updataNodeInMixin();
        },
    },

     destroyed() {},
};